import { AngularFireDatabase } from 'angularfire2/database';
import { Order } from '../model/order';
import { Items, ItemChoice } from '../model/items';

export class OrderHelper {

    constructor(private db: AngularFireDatabase) { }

    ordersList: Order[];
    mpmaDonationCost: number = 2; //[RM 2.00]
    totalBoxesSold: number = 0;
    totalDonations: number = 0;
    returnObject: any = {
        totalBoxesSold: 0,
        totalDonations: 0
    }

    getMPMADonations(): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {
            this.db.list('/order').snapshotChanges().subscribe(
                response => {
                    this.ordersList = response.map(c => (
                        {
                            key: c.payload.key, ...(c.payload.val() as any)
                        }
                    ));
                    if (this.ordersList && this.ordersList.length > 0) {
                        this.totalBoxesSold = this.ordersList.length;
                        this.ordersList.forEach(order => {
                            let itemsList: Items[] = order.items;
                            itemsList.forEach(item => {
                                if(item.itemType && item.itemType != '' && item.itemType.toLowerCase() == 'face mask'){
                                    let itemChoices: ItemChoice[] = item.itemChoices;
                                    itemChoices.forEach(itemChoice => {
                                        if (itemChoice.isChecked) {
                                            this.totalBoxesSold = this.totalBoxesSold + parseInt(itemChoice.itemChoiceQuantity);
                                        }
                                    });
                                }                                
                            });
                        });
                        this.totalDonations = this.totalBoxesSold * this.mpmaDonationCost;
                        this.returnObject = {
                            totalBoxesSold: this.totalBoxesSold,
                            totalDonations: this.totalDonations
                        }
                        resolve(this.returnObject);
                    }
                }, error => {
                    console.log(error);
                    reject(this.returnObject);
                }
            )
        });
        return promise;
    }
}